<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.clear_shared')}}</div>
    <div slot="body">
      <!-- <a-alert class="mb-2" type="warning" :message="$t('bill.ignore_tips')" /> -->
      <dialog-selected-tips :count="params.data.length" :action="$t('bill.clear_shared')" :name="$t('bill.cpp')" />
      <dialog-table :data="params.data" :columns="columns" />
      <a-form :form="form.fc" hideRequiredMark v-bind="formItemLayout">
        <a-row v-for="(sharedItem, index) in sharedList" :key="index">
        <a-col :span="12">
          <a-form-item :label="$t('bill.project')">{{sharedItem[0]}}</a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('bill.count')">{{sharedItem[1]}}</a-form-item>
        </a-col>
      </a-row>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
// import expectStatus from '@/constants/expectStatus'

export default {
  name: 'CppSharedClearDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { projects_cpp = [{ project_id: '', cpp_count: 1 }] } = this.params.data[0]
    const defaultShared = projects_cpp.map(item => {
      return [item.project_id, item.cpp_count]
    })
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      sharedList: defaultShared,
    }
  },
  computed: {
    ...mapGetters(['scope']),
    columns () {
      const showFields = ['category', 'reservation_years', 'cpp_count']
      return this.params.columns.filter((item) => { return showFields.includes(item.field) })
    },
  },
  created () {
    this.$p = new this.$Manager('projects', 'v1')
    this.fetchProjects()
  },
  methods: {
    async fetchProjects () {
      const { projects_cpp = [] } = this.params.data[0]
      const projectIds = projects_cpp.map(item => item.project_id)
      try {
        const res = await this.$p.list({
          params: {
            domain_id: this.params.domain_id,
            filter: `id.in(${projectIds.join(',')})`,
          },
        })
        const projectList = res.data.data
        const defaultShared = projects_cpp.map(item => {
          let project_name = item.project
          const targets = projectList.filter(p => p.id === item.project_id)
          if (targets.length) {
            project_name = targets[0].name
          }
          return [project_name, item.cpp_count]
        })
        this.sharedList = defaultShared
      } catch (err) {}
    },
    async handleConfirm () {
      this.loading = true
      const manager = new this.$Manager('reservations', 'v1')
      try {
        await manager.performAction({
          id: this.params.resId,
          action: 'clear',
        })
        this.params.refresh && this.params.refresh()
        this.cancelDialog()
        this.$message.success(this.$t('compute.text_423'))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
